import { jsxs as e, jsx as n } from "react/jsx-runtime";
import { Button as t } from "../../components/Button/index.js";
import '../../assets/index7.css';const _ = "HeadingActions-module__root___HqVaZ", m = "HeadingActions-module__actions___Mgjes", g = "HeadingActions-module__heading___PqPTL", o = {
  root: _,
  actions: m,
  heading: g
};
function v({
  heading: s,
  primaryActionLabel: a,
  primaryActionIcon: c,
  onPrimaryAction: r,
  secondaryActions: d = []
}) {
  return /* @__PURE__ */ e("div", { className: o.root, children: [
    /* @__PURE__ */ n("div", { className: o.heading, children: s }),
    /* @__PURE__ */ e("div", { className: o.actions, children: [
      d.map((i, l) => /* @__PURE__ */ n(
        t,
        {
          variant: "tertiary",
          "aria-label": i.label,
          onClick: i.onClick,
          children: i.icon
        },
        l
      )),
      a && /* @__PURE__ */ n(
        t,
        {
          variant: "primary",
          leftSection: c,
          onClick: r,
          children: a
        }
      )
    ] })
  ] });
}
export {
  v as HeadingActions
};
